import React from 'react';
import { exclamationTriangle } from '@mlc/symbols';
import { Card, AEMContent, Text, Svg } from '@mlc/web-ui-toolkit';
import HeaderBanner from '../HeaderBanner/HeaderBanner';

interface Props {
	headerMessage?: string;
	message: string;
	children: JSX.Element;
}

const ErrorPage: React.FunctionComponent<Props> = ({
	headerMessage,
	message,
	children,
}) => {
	return (
		<div role="alert" aria-live="assertive">
			{headerMessage && <HeaderBanner title={headerMessage} asHero={true} />}
			<Card
				display="flex"
				flexDirection="column"
				paddingTop={10}
				paddingBottom={10}
				marginBottom={10}
				alignItems="center"
			>
				<Svg
					symbol={exclamationTriangle}
					width="60px"
					originalSize={true}
					margin={0}
					color="mlcMediumGrey"
				/>
				<Text
					marginTop={4}
					marginBottom={7}
					fontSize="tiny"
					fontWeight="semibold"
					el="h2"
				>
					{message}
				</Text>
				{children}
			</Card>
		</div>
	);
};

export default ErrorPage;
